export function findDuplicatesById<T>(items: T[], key: keyof T): Array<T[keyof T]> {
  const itemsMap = new Map<T[keyof T], number>(items.map((item) => [item[key], 0]));
  if (itemsMap.size === items.length) {
    return [];
  }

  const duplicates: Array<T[keyof T]> = [];
  items.forEach((item) => {
    const counter = itemsMap.get(item[key])!;
    if (counter === 1) {
      duplicates.push(item[key]);
    }
    itemsMap.set(item[key], counter + 1);
  });
  return duplicates;
}
